import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import ScrollToTop from "./components/common/ScrollToTop";
import Loading from "./components/common/Loading";
import ErrorBoundary from "./components/error/ErrorBoundary";
import Layout from "./components/layout/Layout";
import { useAOS } from "./hooks/useAOS";

// Lazy pages
const HomePageLayout = lazy(() => import("./pages/gateway/HomePageLayout"));

const HomePage = lazy(() => import("./pages/trading/HomePage"));
const ServicesPage = lazy(() => import("./pages/trading/ServicesPage"));
const ProductsPage = lazy(() => import("./pages/trading/ProductsPage"));
const ContactPage = lazy(() => import("./pages/trading/ContactPage"));
const TradingPage = lazy(() => import("./pages/trading/TradingPage"));
const PumpsPage = lazy(() => import("./pages/pumps/PumpsPage"));
const ControlPanelsPage = lazy(() => import("./pages/control-panels/ControlPanelsPage"));

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Suspense fallback={<Loading />}>
        <Routes location={location} key={location.pathname}>
          
          {/* Gateway */}
          <Route path="/" element={<HomePageLayout />} />

          {/* Dedicated Pages */}
          <Route path="/pumps" element={<PumpsPage />} />
          <Route path="/control-panels" element={<ControlPanelsPage />} />

          {/* Website A */}
          <Route path="/trading" element={<Layout />}>
            <Route index element={<TradingPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="demo" element={<TradingPage />} />
            <Route path="home" element={<HomePage />} />
          </Route>

        </Routes>
      </Suspense>
    </AnimatePresence>
  );
};

const App = () => {
  useAOS();

  return (
     <ErrorBoundary>
      <Router>
        <ScrollToTop />

        {/* Routes */}
        <AnimatedRoutes />
      </Router>
    </ErrorBoundary>
  );
};

export default App;
